import React, { FC } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ViewStyle } from "react-native"
import { Screen } from "../../../components"
// import { useStores } from "../../models"
import { color } from "../../../theme"

const ROOT: ViewStyle = {
  flexGrow: 1
}

export const QuickInputScreen: FC<{ colorScheme?: "light" | "dark" }> = observer(function QuickInputScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.primary : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}>
    </Screen>
  )
})

// QuickInputScreen.options = {
//   statusBar: { style: "light", backgroundColor: color.primary },
//   bottomTabs: { visible: true },
//   navigationBar: { backgroundColor: color.palette.white }
// }
